import { Modal, Alert } from "bootstrap";
import { EventService } from "./event-service.js";
import { getWwwUrl, detectLanguageParameter } from '../components/utils.js';

export default class AuthService extends EventService {
	constructor() {
		super();

		this.closed = false;
		this.activeModal = null;
		this.dialog = $("#verify-dialog");
		this.useModal = this.dialog.length === 0 || this.dialog.data('static') !== true;
		this.authLinkedIn = config.public_url + "login/linkedin";
		this.authDialogApi = config.public_url + "api/auth/dialog";
		this.authEmailApi = config.public_url + "api/auth/email";
		this.authCodeApi = config.public_url + "api/auth/code";
		this.authSocialApi = config.public_url + "api/auth/";

		this.authName = null;
		this.authEmail = null;

		console.log("config", config);
	}

	#checkEmbeddedBrowser() {
		if (
			window.navigator.userAgent.indexOf("[FBAN/") !== -1 ||
			window.navigator.userAgent.indexOf("[FB_IAB/") !== -1
		) {
			// show warning text
			this.dialog.find(".warning-text.embedded-browser").show();

			// disable Facebook button & copy for Google button
			let button = this.dialog
				.find(".btn-facebook")
				.prop("disabled", true)
				.clone();

			// make Google button
			button
				.find(".fab")
				.removeClass("fa-facebook-f")
				.addClass("fa-google")
				.css({ color: "#DB4437", left: "12px" });
			button.html(button.html().replace("Facebook", "Google"));
			this.dialog.find(".google-login-row").replaceWith(button);
		}
	}

	#initGoogleLogin() {
		const self = this;

		// add google sign in button
		if (self.dialog.find(".google-login-row").length) {
			try {
				google.accounts.id.initialize({
					client_id: config.google_client_id, // $('meta[name="google-signin-client_id"]').attr('content'),
					use_fedcm: true,
					// use_fedcm_for_prompt: true,
					redirect_uri: config.admin_url+'integration/oauth2/type/Google/noAdmin/1',
					// state_cookie_domain: 'https://'+window.location.hostname.match(/[^\.]*\.[^.]*$/)[0],
					callback: (response) => {
						// show loading animation
						self.dialog.addClass("loading");

						self.socialLogin("google", response.credential);
					},
					intermediate_iframe_close_callback: (err) => {
						console.log("err", "notification", err);
					},
				});
				setTimeout(() => {
					let renderButton = function () {
						google.accounts.id.renderButton(
							self.dialog.find(".google-login-row").get(0),
							{
								size: "large",
								text: "continue_with",
								logo_alignment: "left",
								locale: $("html").attr("lang"),
								width: self.dialog
									.find(".google-login-row")
									.width(),
							}
						);
					};

					renderButton();
					// new ResizeObserver(renderButton).observe(
					// 	self.dialog.find(".google-login-row").get(0)
					// );

					// google.accounts.id.prompt();
				}, 200);
			} catch (error) {
				console.error("Error initializing Google Sign-In", error);
			}
		}
	}

	#initListeners() {
		if (this.useModal) {
			this.#checkEmbeddedBrowser();

			$("body").append(this.dialog);

			this.setEmailVerificationListener();
			this.setEmailConfirmationListener();
			this.setFacebookListener();
			this.setLinkedinListener();
			this.#initGoogleLogin();
		} else {
			this.#checkEmbeddedBrowser();
			this.setEmailVerificationListener();
			this.setEmailConfirmationListener();
			this.setFacebookListener();
			this.setLinkedinListener();
			this.#initGoogleLogin();
		}
	}

	#isTokenExpired(token) {
		const data = this.#getTokenPayload(token);
		if (!data) {
			return true;
		}

		const expiry = data.exp;

		return Math.floor(new Date().getTime() / 1000) >= expiry;
	}

	#getTokenPayload(token) {
		token = token.toString();

		if (token.indexOf(".") === -1) {
			return false;
		}

		const decodedData = atob(token.split(".")[1]);
		const utf8data = new Uint8Array(decodedData.length);
		const decoder = new TextDecoder("utf-8");
		for (let i = 0; i < decodedData.length; i++) {
			utf8data[i] = decodedData.charCodeAt(i);
		}

		return JSON.parse(decoder.decode(utf8data));
	}

	async getDialog() {
		console.log("getDialog");

		const self = this;
		let language = detectLanguageParameter();
		let url = this.authDialogApi;

		if (language) {
			url += "/" + language;
		}

		return axios.get(url).then((response) => {
			console.log("Dialog loaded");

			self.dialog = $(response.data);
			self.useModal = !self.dialog.data("static");

			self.#initListeners();
		});
	}

	async showDialog() {
		console.log("showDialog");

		const self = this;

		this.closed = false;

		if (this.useModal && this.dialog.length === 0) {
			await this.getDialog();
		} else {
			// Reset email verification fields
			this.dialog.find("#verify-email-content").removeClass("d-none");
			this.dialog.find("#confirm-email-content").addClass("d-none");
			this.dialog.find("#verify-name").val('');
			this.dialog.find("#verify-email").val('');
			this.dialog.find("#confirmation-code").val('');
		}

		// self.dialog.modal('show');
		self.activeModal = new Modal("#verify-dialog", {});
		self.activeModal.show();

		this.dialog.find('[data-bs-dismiss]').on('click', event => {
			$(".with-spinner.loading").removeClass("loading");
			$(".btn-loading-animation").removeClass("btn-loading-animation");
		});
		$('.modal-backdrop').on('click', event => {
			$(".with-spinner.loading").removeClass("loading");
			$(".btn-loading-animation").removeClass("btn-loading-animation");
		});
		this.dialog.on('hidden.bs.modal', event => {
			$(".with-spinner.loading").removeClass("loading");
			$(".btn-loading-animation").removeClass("btn-loading-animation");
		})
	}

	async requestVerification(data) {
		console.log("requestVerification", data);

		const self = this;

		return axios
			.put(this.authEmailApi, data)
			.then((response) => {
				console.log("company_login_email_verify", response);
				setTimeout(function () {
					// delay a bit for smooth effect
					// hide loading animation
					self.dialog.removeClass("loading");

					if (response.status === 204) {
						$("#verify-email-content").addClass("d-none");
						$("#confirm-email-content").removeClass("d-none");

						$("#confirmation-code").trigger("focus");
					} else {
						self.dialog.find(".error-text.invalid-email").fadeIn();
					}
				}, 400);
			})
			.catch((error) => {
				console.log("company_login_email_verify error", error);
				// hide loading animation
				self.dialog.removeClass("loading");

				// show error
				self.dialog.find(".error-text.invalid-email").fadeIn();
			});
	}

	async sendVerification(data) {
		const self = this;

		return axios
			.put(this.authCodeApi, data)
			.then((response) => {
				console.log("company_login_email", response);
				setTimeout(function () {
					// delay a bit for smooth effect
					// hide loading animation
					self.dialog.removeClass("loading");

					if (response.status === 200) {
						// save hash
						self.storeToken(response.data.token);

						self.closeDialog({
							response: response.data,
							request: data,
						});
					} else {
						self.dialog.find(".error-text.invalid-email").fadeIn();
					}
				}, 400);
			})
			.catch((error) => {
				console.log("company_login_email_verify error", error);
				// hide loading animation
				self.dialog.removeClass("loading");

				// show error
				self.dialog.find(".error-text.invalid-email").fadeIn();
			});
	}

	async socialLogin(type, token) {
		console.log("socialLogin", type, token);

		const self = this;

		return axios
			.put(this.authSocialApi + type, { token: token })
			.then((response) => {
				console.log(type, response);
				setTimeout(function () {
					// delay a bit for smooth effect
					// hide loading animation
					self.dialog.removeClass("loading");

					if (response.status === 200) {
						// save hash
						self.storeToken(response.data.token);
						// setHash(data.hash || "", $('#remember-me').prop('checked'));

						// callback
						self.closeDialog(response.data);
					} else {
						self.resetDialog(response.data);
					}
				}, 400);
			})
			.catch((error) => {
				console.log(type + " login error", error);
				self.resetDialog(error);
			});
	}

	closeDialog(eventData = {}) {
		console.log("closeDialog");

		const self = this;

		if (this.closed) {
			return false;
		}

		this.closed = true;

		$("#remember-me").prop("checked", false);

		if (this.useModal && this.activeModal) {
			this.activeModal.hide();
			this.activeModal = null;
		}

		// hide loading animation
		setTimeout(function () {
			self.dialog.removeClass("loading");

			// hide popup info
			self.dialog.find(".popup-info-text").hide();

			$('.btn-loading-animation').removeClass('btn-loading-animation');
		}, 400);

		this.checkAuthLoginBox();

		this.trigger("closed", eventData);
	}

	resetDialog(eventData = {}) {
		console.log("resetDialog");

		$("#remember-me").prop("checked", false);

		this.dialog.removeClass("loading");

		// hide popup info
		this.dialog.find(".popup-info-text").hide();

		this.trigger("reset", eventData);

		$('.btn-loading-animation').removeClass('btn-loading-animation');
	}

	setEmailVerificationListener() {
		const self = this;

		// auth e-mail
		self.authName = null;
		self.authEmail = null;
		self.dialog
			.find(".btn-email")
			.off()
			.on("click", function (event) {
				event.preventDefault();

				// hide error
				self.dialog.find(".error-text").hide();

				// Check name
				self.authName = $("#verify-name").val().trim();
				if (!self.authName || self.authName.indexOf("@") > -1) {
					self.dialog.find(".error-text.invalid-name").fadeIn();

					return false;
				} else if (self.authName.length > 100) {
					self.dialog.find(".error-text.too-long-name").fadeIn();

					return false;
				}

				// Check email
				self.authEmail = $("#verify-email").val().trim();
				if (!self.authEmail.isValidEmail()) {
					self.dialog.find(".error-text.invalid-email").fadeIn();

					return false;
				}

				// show loading animation
				self.dialog.addClass("loading");

				// hide popup info
				self.dialog.find(".popup-info-text").hide();

				// google reCAPTCHA Enterprise
				reCaptchaService.runWithCaptcha(
					"company_login_email_verify",
					(token, withCheckbox = false) =>
						self.requestVerification({
							recaptcha_token: token,
							recaptcha_checkbox: withCheckbox,
							email: self.authEmail,
						})
				);
				// reCaptchaService.requestToken('company_login_email_verify')
				// 	.then((token) => self.requestVerification({
				// 		recaptcha_token: token,
				// 		email: self.authEmail
				// 	}));

				// reCAPTCHA_Enterprise({
				// 	action: 'company_login_email_verify',
				// 	url: self.authEmailApi,
				// 	data: {
				// 		email: self.authEmail
				// 	},
				// 	success: function (data) {
				// 		console.log('company_login_email_verify', data);
				// 		setTimeout(function () { // delay a bit for smooth effect
				// 			// hide loading animation
				// 			self.dialog.removeClass('loading');

				// 			if (typeof data.success !== 'undefined' && data.success) {
				// 				$('#verify-email-content').addClass('d-none');
				// 				$('#confirm-email-content').removeClass('d-none');

				// 				$('#confirmation-code').focus();
				// 			}
				// 			else {
				// 				self.dialog.find('.error-text.invalid-email').fadeIn();
				// 			}
				// 		}, 400);
				// 	},
				// 	error: function (msg) {
				// 		console.log('company_login_email_verify error', msg);
				// 		// hide loading animation
				// 		self.dialog.removeClass('loading');

				// 		// show error
				// 		self.dialog.find('.error-text.invalid-email').fadeIn();
				// 	}
				// });
			});
	}

	setEmailConfirmationListener() {
		const self = this;

		// confirm email
		self.dialog
			.find(".btn-confirm-email")
			.off()
			.on("click", function (event) {
				event.preventDefault();

				// hide error
				self.dialog.find(".error-text").hide();

				// Check code empty
				let code = $("#confirmation-code").val().trim();
				if (code === "" || code.length !== 10) {
					self.dialog.find(".error-text.invalid-code").fadeIn();

					return false;
				}

				// show loading animation
				self.dialog.addClass("loading");

				// hide popup info
				self.dialog.find(".popup-info-text").hide();

				// google reCAPTCHA Enterprise
				reCaptchaService.runWithCaptcha(
					"company_login_email",
					(token, withCheckbox = false) =>
						self.sendVerification({
							recaptcha_token: token,
							recaptcha_checkbox: withCheckbox,
							name: self.authName,
							email: self.authEmail,
							token: code,
						})
				);

				// google reCAPTCHA Enterprise
				// reCAPTCHA_Enterprise({
				// 	action: 'company_login_email',
				// 	url: self.authCodeApi,
				// 	data: {
				// 		name: self.authName,
				// 		token: code
				// 	},
				// 	success: function (data) {
				// 		console.log('company_login_code', data);

				// 		setTimeout(function () { // delay a bit for smooth effect
				// 			if (typeof data.success !== 'undefined' && data.success) {
				// 				// save hash
				// 				setHash(data.hash || "", $('#remember-me').prop('checked'));

				// 				// callback
				// 				// close(true, data);
				// 			}
				// 			else {
				// 				// hide loading animation
				// 				self.dialog.removeClass('loading');

				// 				// show error
				// 				self.dialog.find('.error-text.invalid-code').fadeIn();
				// 			}
				// 		}, 400);
				// 	},
				// 	error: function (msg) {
				// 		console.log('company_login_code error', msg);

				// 		// hide loading animation
				// 		self.dialog.removeClass('loading');

				// 		// show error
				// 		self.dialog.find('.error-text.invalid-code').fadeIn();
				// 	}
				// });
			});
	}

	setFacebookListener() {
		const self = this;

		self.dialog
			.find(".btn-facebook")
			.off()
			.on("click", function (event) {
				event.preventDefault();

				// show loading animation
				self.dialog.addClass("loading");

				// show popup info
				self.dialog.find(".popup-info-text").show();

				// init Facebook API
				FB.init({
					appId: config.fb_app_id,
					xfbml: true,
					version: "v10.0",
					cookie: true,
				});

				setTimeout(() => {
					FB.login(
						function (response) {
							console.log("FB login", response);
							if (response.status === "connected") {
								self.socialLogin(
									"facebook",
									response.authResponse.accessToken
								);
							} else {
								self.resetDialog();
							}
						},
						{ scope: "email" }
					);
				}, 400);
			});
	}

	setLinkedinListener() {
		const self = this;

		// auth LinkedIn
		self.dialog
			.find(".btn-linkedin")
			.off()
			.on("click", function (event) {
				event.preventDefault();

				// show loading animation
				self.dialog.addClass("loading");

				// show popup info
				self.dialog.find(".popup-info-text").show();

				// open linkedin in iframe
				let win = window.open(
					encodeURI(self.authLinkedIn),
					"LinkedIn Login",
					'width=800, height=600, left=300, top=100, rel="opener"'
				);

				window.addEventListener('message', function (event) {
					win.close();
					self.closeDialog({ token: event.data });
				}, false);

				let checkConnect = setInterval(function () {
					if (!win || (win && win.closed)) {
						console.log('win closed', win.closed);

						clearInterval(checkConnect);

						return;
					};

					win.postMessage('linkedin-request', config.public_url);
				}, 100);
			});
	}

	checkAuth() {
		return !this.#isTokenExpired(this.retrieveToken());
	}

	storeToken(value) {
		Cookie.set(
			"trust-token",
			value,
			$("#remember-me").prop("checked") ? 24 : 1,
			true
		);
	}

	removeToken() {
		Cookie.delete("trust-token", true);
	}

	retrieveToken() {
		return Cookie.get("trust-token");
	}

	retrieveHash() {
		if (this.checkAuth()) {
			const data = this.#getTokenPayload(this.retrieveToken());
			return data && data.hash;
		}
		return null;
	}

	retrievePublicId() {
		if (this.checkAuth()) {
			const data = this.#getTokenPayload(this.retrieveToken());
			return data && data.publicId;
		}
		return null;
	}

	checkAuthLoginBox() {
		if (this.checkAuth()) {
			const data = this.#getTokenPayload(this.retrieveToken());
			let loginBox = $("#ti-login-card");
			// let language = detectLanguageParameter();
			let path = `/reviewer/${data.publicId}`;
			let url = getWwwUrl() + path;

			// if (language) {
			// 	url += config.env === 'prod' ? `/lang/${language}` : `?lang=${language}`;
			// }

			if (loginBox.length) {
				loginBox.find(".name-holder").text(`, ${data.name}`);
				loginBox.find(".logout-holder a.btn-link").attr('href', url);
				if (location.href.indexOf(path) > -1) {
					loginBox.find(".logout-holder a.btn-link").css('display', 'none');
				}

				loginBox.find(".login-holder").addClass("d-none");
				loginBox.find(".logout-holder").removeClass("d-none");
			}
		}
	}

	init() {
		const self = this;

		let loginBox = $("#ti-login-card");

		if (loginBox.length) {
			console.log('loginBox');

			// check login
			this.checkAuthLoginBox();

			// login
			loginBox.find(".btn-login").on("click", function (event) {
				event.preventDefault();

				let btn = $(this);
				btn.trigger("blur").addClass("btn-loading-animation");

				self.showDialog();

				self.on("closed", function () {
					self.checkAuthLoginBox();
					btn.removeClass("btn-loading-animation");
					btn.removeClass("loading");
					// location.reload();
				});

				self.on("reset", function () {
					btn.removeClass("btn-loading-animation");
					btn.removeClass("loading");
					self.dialog.find(".modal-loading").remove();
				});
				// auth('dialog', function (success, r) {
				// 	if (success) {
				// 		location.reload();
				// 	}
				// 	else {
				// 		btn.removeClass('btn-loading-animation');
				// 	}
				// }, false);
			});

			// logout
			loginBox.find(".btn-logout").on("click", function (event) {
				event.preventDefault();

				self.removeToken();
				self.checkAuthLoginBox();
				$(this).trigger("blur").addClass("btn-loading-animation");

				window.location.reload();
			});

			$(document).on("click", ".ti-review-footer .report a.btn, .review-actions .btn-report", function (event) {
				event.preventDefault();

				let btn = $(this);
				let link = btn.attr("href");

				if (!self.checkAuth()) {
					btn.trigger("blur").addClass("btn-loading-animation");

					self.showDialog();

					self.on("closed", function () {
						self.checkAuthLoginBox();
						btn.removeClass("btn-loading-animation");
						location.href = link;
					});

					self.on("reset", function () {
						btn.removeClass("btn-loading-animation");
						self.dialog.find(".modal-loading").remove();
					});
				} else {
					location.href = link;
				}
			});
		}

		if (!this.useModal) {
			console.log('staticModal');
			setTimeout(() => this.#initListeners(), 500);
		}
	}
}
